import { createReducer } from '@reduxjs/toolkit';
import { listMarket } from './actions';
const initialState = {};
export default createReducer(initialState, (builder) => {
    builder.addCase(listMarket, (state, action) => {
        return Object.assign(Object.assign({}, state), { [action.payload.chainId]: action.payload.markets });
    });
});
